module.exports = __webpack_public_path__ + "img/矩形 2591.91a903b3.png";